import {useRouter} from 'next/router'
import Link from 'next/link'
import ButtonLink from '@helios/ButtonLink'
import {usePostHog} from 'posthog-js/react'

import {captureAnalyticsEvent} from '@/lib/analytics'

function LeadFormLink({
  variant,
  tone,
  size,
  iconLeft,
  iconRight,
  arrow,
  className,
  children,
}) {
  const router = useRouter()
  const posthog = usePostHog()
  const href = {
    pathname: router.pathname,
    query: {...router.query, requestInfo: true},
  }
  if (href.pathname.includes('/programs') && href.query.program == null) {
    href.query.program = false
  }

  const rendersAsButton = Boolean(
    variant || tone || size || iconLeft || iconRight || arrow,
  )
  const handleClick = () => {
    captureAnalyticsEvent(posthog, 'cta_clicked', {
      cta_id: 'request_info',
      destination: '/request-info',
      placement: router.pathname,
    })
  }

  if (!rendersAsButton) {
    return (
      <Link
        href={href}
        as="/request-info"
        shallow
        scroll={false}
        className={className}
        onClick={handleClick}
      >
        {children}
      </Link>
    )
  }

  return (
    <ButtonLink
      href={href}
      as="/request-info"
      shallow
      scroll={false}
      variant={variant}
      tone={tone}
      size={size}
      iconLeft={iconLeft}
      iconRight={iconRight}
      arrow={arrow}
      className={className}
      onClick={handleClick}
    >
      {children}
    </ButtonLink>
  )
}

export default LeadFormLink
